import { operatingCredit } from '@/api/user'
import store from '@/store'

const state = {
  aliyun_fp_um: null
}

const mutations = {
  SET_ALIYUN_FP_UM: (state, aliyunFpUm) => {
    state.aliyun_fp_um = aliyunFpUm
  }
}

const actions = {
  monitorAliyunFP({ commit, rootState }) {
    if (!window.ALIYUN_FP) {
      setTimeout(() => { store.dispatch('config/monitorAliyunFP') }, 2000)
      return
    }

    window.ALIYUN_FP.use('um', (state, um) => {
      if (state !== 'loaded') {
        setTimeout(() => { store.dispatch('config/monitorAliyunFP') }, 2000)
        return
      }

      um.init(rootState.settings.aliyunFP, (initStats) => {
        if (initStats !== 'success') {
          setTimeout(() => { store.dispatch('config/monitorAliyunFP') }, 2000)
          return
        }

        commit('SET_ALIYUN_FP_UM', um)

        store.dispatch('config/handleAliyunFPToken')
      })
    })
  },
  handleAliyunFPToken({ commit }) {
    if (!state.aliyun_fp_um) {
      setTimeout(() => { store.dispatch('config/monitorAliyunFP') }, 2000)
      return
    }

    const device_token = state.aliyun_fp_um.getToken()
    if (!device_token) {
      setTimeout(() => { store.dispatch('config/handleAliyunFPToken') }, 2000)
      return
    }

    operatingCredit({ device_token })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
